export default __webpack_public_path__ + "static/media/040-magic hat.a0a19032.svg";